import { PROTOCOL, TChannelProtocol } from '@/entities/channel';

const AUTHORIZABLE_CHANNEL_PROTOCOLS = new Set<TChannelProtocol>([
  PROTOCOL.TELEGRAM_BOT,
  PROTOCOL.WHATSAPP_GRAY,
  PROTOCOL.TELEGRAM_PERSONAL,
  PROTOCOL.MAX,
  PROTOCOL.MAX_PERSONAL,
  PROTOCOL.AVITO,
  PROTOCOL.WILDBERRIES,
  PROTOCOL.OZON,
  PROTOCOL.VK,
]);

export const canAuthorizeChannelProtocol = (protocol: TChannelProtocol): boolean =>
  AUTHORIZABLE_CHANNEL_PROTOCOLS.has(protocol);

// Personal messenger channels are identified by the connected phone number —
// once authorized, the number replaces the tariff in the channel list.
const PERSONAL_CHANNEL_PROTOCOLS = new Set<TChannelProtocol>([
  PROTOCOL.TELEGRAM_PERSONAL,
  PROTOCOL.WHATSAPP_GRAY,
  PROTOCOL.MAX_PERSONAL,
]);

/**
 * Phone number to show instead of the tariff for authorized personal channels;
 * undefined keeps the default tariff rendering.
 */
export const getPersonalChannelPhoneOverride = (
  protocol: TChannelProtocol,
  phoneNumber?: string,
): string | undefined => {
  if (!PERSONAL_CHANNEL_PROTOCOLS.has(protocol)) return undefined;
  const phone = phoneNumber?.trim();
  return phone ? phone : undefined;
};
